<template>
    <div>
        <iframe :src="grafanaUrl" class="frameClass" hight='auto' id="frameBox" frameborder="no"></iframe>
    </div>
</template>
<script>
    export default{
        mounted(){
            const oIframe = document.getElementById('frameBox');            
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.height = (Number(deviceHeight) - 120) + 'px';
        },        
    }
</script>
<style scoped>
    .frameClass{
        width: 100%;
    }
</style>
